var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorageEntryManage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.884 15.92H11.52a.638.638 0 010-1.274h2.727v-8.27L8.187 2.4l-5.913 3.97V9.01a.638.638 0 01-1.274 0V6.032c0-.213.106-.412.282-.53L7.83 1.108a.639.639 0 01.704-.004l6.7 4.394c.18.118.288.319.288.534v9.25a.638.638 0 01-.637.638z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61 13.316H1.72a.638.638 0 010-1.274h5.89a.638.638 0 010 1.274z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.628 15.736a.636.636 0 010-.9l2.155-2.157-2.155-2.156a.636.636 0 11.901-.901l2.55 2.553a.713.713 0 010 1.008l-2.55 2.551a.634.634 0 01-.9.002z"
  }))));
}
export default SvgStorageEntryManage;